module.exports = __webpack_public_path__ + "img/wheel.b1c2e44d.png";